import { useState } from "react";
import { get } from "../api/apis";

export const usePrevision = () => {
  const [listadoAfp, setListadoAfp] = useState([]);
  const [listadoPrevision, setListadoPrevision] = useState([]);

  const getListaAfp = async (api, params) => {
    if (params?.jubilado === '') {
      setListadoAfp([]);
    } else {
      const resp = await get(api, params);
      if (Array.isArray(resp?.data?.data)) {
        setListadoAfp(resp.data.data);
      } else if (Array.isArray(resp?.data)) {
        setListadoAfp(resp.data);
      } else {
        setListadoAfp([]);
      }
    }
  };

  const getListaSalud = async (api, params) => {
    const resp = await get(api, params);
    if (Array.isArray(resp?.data?.data)) {
      setListadoPrevision(resp.data.data);
    } else if (Array.isArray(resp?.data)) {
      setListadoPrevision(resp.data);
    } else {
      setListadoPrevision([]);
    }
  };

  return { getListaAfp, getListaSalud, listadoAfp, listadoPrevision }
}